var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 10.1944V8.30556C17.75 4.74383 17.75 2.96297 16.6435 1.85648C15.5371 0.75 13.7561 0.75 10.1944 0.75H8.30556C4.74383 0.75 2.96297 0.75 1.85648 1.85648C0.75 2.96297 0.75 4.74383 0.75 8.30556V10.1944C0.75 13.7561 0.75 15.5371 1.85648 16.6435C2.96297 17.75 4.74383 17.75 8.30556 17.75H10.1944C13.7561 17.75 15.5371 17.75 16.6435 16.6435C17.75 15.5371 17.75 13.7561 17.75 10.1944Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.65 7.15003C11.65 5.82454 10.5755 4.75 9.24998 4.75C7.92446 4.75 6.84998 5.82454 6.84998 7.15003C6.84998 8.47557 7.92446 9.55007 9.24998 9.55007C10.5755 9.55007 11.65 8.47557 11.65 7.15003Z",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.5501C13.25 11.341 11.4591 9.55005 9.25 9.55005C7.04086 9.55005 5.25 11.341 5.25 13.5501",
    stroke: "#3469E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.fcc1160c20b2a678c392cf9e4c0d1280.svg";
export { ForwardRef as ReactComponent };